import {
    Alert,
    Autocomplete,
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    Grid,
    Link,
    Menu,
    MenuItem,
    Paper,
    TextField,
    Tooltip
} from "@mui/material"
import React, {useState} from "react"
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {Add, Close, Delete, Edit, Image, MoreHoriz, Save, Settings} from "@mui/icons-material";
import VisuallyHiddenInput from "../common/VisuallyHiddenInput";
import {download} from "../../services/FileService";

const fileColumns = [
    {id: 'name', label: 'Fájl Neve'},
    {id: 'description', label: 'Leírás'},
    {id: 'createdAt', label: 'Feltöltve'},
    {id: 'uploadedBy', label: 'Feltöltő'},
];

export default function ProductEditorTemplate(props) {

    const unit = ' ' + (props.product?.unitOfMeasurement != null ? "(" + props.product?.unitOfMeasurement + ")" : "")

    const columns = [
        {id: 'subStorage', label: 'Alraktár', subId: "name", width: "300px"},
        {id: 'amount', label: 'Mennyiség' + unit},
        {id: 'minimumStockInStorage', label: 'Minimális mennyiség' + unit, editable: true, type: "number"},
        {id: 'purchasePrice', label: 'Vásárlási Ár (Ft)', editable: true, type: "number"},
        {id: 'sellingPrice', label: 'Eladási Ár (Ft)', editable: true, type: "number"},
        {id: 'vat', label: 'ÁFA (%)', editable: true, type: "number"},
        {id: 'factoryNumber', label: 'Gyári Szám', editable: true},
        {id: 'guarantee', label: 'Garancia Lejárta', editable: true, type: "date"},
        {id: 'expiryDate', label: 'Szavatosság Lejárta', editable: true, type: "date"},
        {id: 'updatedAt', label: 'Módosítva', width: "150px"},
    ];

    const {
        id,
        onChangeCheckbox,
        onChangeSelectItem,
        onChangeProductItem,
        create,
        update,
        updateProductItem,
        correctAmount,
        message,
        waitingForServer,
        navigate,
        waitingForCorrection
    } = props
    const {unitOfMeasurement, stockManagement, productItems} = props.product ?? {}

    const [open, setOpen] = React.useState(false);
    const [currentItem, setCurrentItem] = React.useState(undefined);
    const [indexOfEditedRow, setIndexOfEditedRow] = React.useState();

    const [fileContextAnchor, setFileContextAnchor] = useState(null);
    const fileContextOpen = Boolean(fileContextAnchor);
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileContextButtonClick = (event, file) => {
        setSelectedFile(file);
        setFileContextAnchor(event.currentTarget);
    }
    const handleFileContextClose = () => {
        setSelectedFile(null);
        setFileContextAnchor(null);
    }

    const handleClickOpen = (row) => {
        setCurrentItem(row)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [openFileDialog, setOpenFileDialog] = React.useState(false);
    const [fileDialogCurrentItem, setFileDialogCurrentItem] = React.useState(undefined);

    const handleFileDialogClickOpen = (item) => {
        setFileDialogCurrentItem(item)
        setOpenFileDialog(true);
    };

    const handleFileDialogClose = () => {
        setOpenFileDialog(false);
    };

    const createInputField = ({name, label, required = false, autoFocus = false, disabled = false}) =>
        <Grid item lg={5} md={10} xs={20}>
            <TextField
                variant="outlined"
                margin="normal"
                required={required}
                fullWidth
                id={name}
                label={label}
                name={name}
                type="text"
                autoFocus={autoFocus}
                autoComplete="off"
                onChange={props.onChange}
                value={props.product?.[name] || ""}
                disabled={disabled}
            />
        </Grid>

    const editOrSaveClick = (e, index) => {
        if (indexOfEditedRow != null) {
            updateProductItem(e, index)
            setIndexOfEditedRow(null)
        } else setIndexOfEditedRow(index)
    }

    const iconButtonStyle = {
        position: "relative",
        top: "0px",
        left: "0px",
        width: "24px",
        color: "#808080",
        cursor: "pointer"
    }

    return (
        <div>
            <div className="register-paper">
                <form id="login" onSubmit={id ? update : create}>
                    <Grid container spacing={2} columns={20}>
                        <Grid item lg={5} sx={{textAlign: "center"}}>
                            {props.loadingImage ? <CircularProgress sx={{margin: "100px"}}/> : props.imgUrl ? <img src={props.imgUrl} style={{maxHeight: "320px", maxWidth: "320px"}}/> :
                                <div style={{backgroundColor: "lightgray", height: "320px", width: "320px", borderRadius: "20px", fontSize: "240px", paddingTop: "0px", color: "white", lineHeight: "240px", margin: "auto"}}>📷️</div>}
                        </Grid>
                        <Grid item lg={15}>
                            <Grid container spacing={2} columns={20}>
                                {id != null && props.product?.name == null ?
                                    <Grid item xs={20}><CircularProgress sx={{margin: "100px"}}/> </Grid> :
                                    <>
                                        {createInputField({
                                            name: "name",
                                            label: "Megnevezés",
                                            required: true
                                        })}
                                        {createInputField({
                                            name: "manufacturer",
                                            label: "Gyártó",
                                            required: true
                                        })}
                                        {createInputField({
                                            name: "centralStorageLocation",
                                            label: "Központi Raktár Hely"
                                        })}
                                        {createInputField({
                                            name: "ean",
                                            label: "EAN"
                                        })}
                                        {createInputField({
                                            name: "articleNumber",
                                            label: "Cikkszám"
                                        })}
                                        {createInputField({
                                            name: "vtszSzjTeszor",
                                            label: "Vtsz/Szj/TESZOR"
                                        })}

                                        <Grid item lg={5} md={10} xs={20}>
                                            <Autocomplete
                                                value={unitOfMeasurement || ""}
                                                margin="normal"
                                                id="unitOfMeasurement"
                                                label="Mértékegység"
                                                name="unitOfMeasurement"
                                                freeSolo
                                                autoSelect
                                                onChange={(event, newValue) => onChangeSelectItem(newValue, "unitOfMeasurement")}
                                                options={["méter", "db", "tétel"]}
                                                getOptionLabel={(m) => m}
                                                style={{marginTop: "16px"}}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Mértékegység"/>
                                                )}
                                            />
                                        </Grid>

                                        {createInputField({
                                            name: "component",
                                            label: "Komponensek"
                                        })}

                                        {createInputField({
                                            name: "dataSheetUrl",
                                            label: "Adatlap URL"
                                        })}
                                        {createInputField({
                                            name: "scoreSheetUrl",
                                            label: "Teljesítménylap URL"
                                        })}
                                        {createInputField({
                                            name: "comment",
                                            label: "Megjegyzés"
                                        })}

                                        <Grid item md={5} xs={20} sx={{padding: "0px", textAlign: "left"}}>
                                            <Autocomplete
                                                value={props.product?.productCategory}
                                                margin="normal"
                                                name="productCategory"
                                                onChange={(event, newValue) => props.onProductCategoryChange(newValue)}
                                                options={props.productCategories}
                                                getOptionLabel={(category) => category.name}
                                                style={{marginTop: "16px"}}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Kategória"/>
                                                )}
                                            />
                                        </Grid>

                                        <Grid item md={5} xs={20} sx={{padding: "0px", textAlign: "left"}}>
                                            <FormControlLabel style={{marginTop: "16px"}} control={<Checkbox
                                                variant="outlined"
                                                margin="normal"
                                                size="large"
                                                id="stockManagement"
                                                label="stockManagement"
                                                name="stockManagement"
                                                onChange={onChangeCheckbox}
                                                checked={stockManagement || false}
                                                value={stockManagement || false}
                                            />} label="Készletkezelés"/>
                                        </Grid>

                                    </>}

                            </Grid>
                        </Grid>
                        {id !== undefined &&
                            <>
                                <Grid item lg={20} md={20} xs={20}>
                                    <Divider/>
                                </Grid>
                                {createInputField({
                                    name: "createdAt",
                                    label: "Létrehozva",
                                    disabled: true
                                })}
                                {createInputField({
                                    name: "updatedAt",
                                    label: "Módosítva",
                                    disabled: true
                                })}
                                <Grid item lg={10} xs={20}></Grid>
                            </>

                        }

                        {message &&
                            <Grid item lg={20} xs={20}>
                                <Alert severity="error" variant="standard"
                                       style={{color: "red"}}>{message}</Alert>
                            </Grid>
                        }

                        <Grid item lg={2} md={5} xs={9}>
                            <Button type="button" fullWidth variant="contained" color="error"
                                    onClick={() => navigate(-1)}>
                                Vissza
                            </Button>
                        </Grid>

                        <Grid item lg={16} md={10} xs={2}></Grid>

                        <Grid item lg={2} md={5} xs={9}>
                            {waitingForServer ? <CircularProgress sx={{margin: "-5px"}}/> :
                                <Button type="submit" fullWidth variant="contained" color="success">
                                    Mentés
                                </Button>}
                        </Grid>
                        <Grid item xs={20}>
                            <Grid container spacing={2} columns={5} sx={{marginTop: "4px"}}>
                                <Grid item xs={5}>
                                    <Table sx={{marginTop: "16px"}}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell key="actions"
                                                           style={{fontWeight: 700, background: "lightgray", minWidth: "50px"}}
                                                           align='left' padding='none' sx={{paddingLeft: "8px"}}>
                                                    <Button variant='contained' color='success' component={'label'}
                                                            sx={{minWidth: "0px", padding: "0px", marginRight: "10px"}}>
                                                        <VisuallyHiddenInput type="file" multiple
                                                                             onChange={props.handleFileChange}/>
                                                        <Add fontSize="large"/>
                                                    </Button>
                                                </TableCell>
                                                {fileColumns.map((column) => (
                                                    <TableCell key={column.id} align={column.align}
                                                               style={{fontWeight: 700, background: "lightgray"}}>
                                                        {column.label}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {props.product?.files?.map((file, index) => (
                                                <TableRow>
                                                    <TableCell sx={{width: "50px", padding: "0px"}}>
                                                        <Button
                                                            onClick={(e) => handleFileContextButtonClick(e, file)}
                                                            variant="text" sx={{
                                                            marginLeft: "0px",
                                                            padding: "5px",
                                                            minWidth: "0px"
                                                        }}>
                                                            <MoreHoriz fontSize="large" color="action"/>
                                                        </Button>

                                                        <Menu
                                                            anchorEl={fileContextAnchor}
                                                            open={fileContextOpen}
                                                            onClose={handleFileContextClose}
                                                            anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                                            transformOrigin={{vertical: "top", horizontal: "right"}}
                                                        >
                                                            <MenuItem onClick={() => {
                                                                handleFileContextClose()
                                                                handleFileDialogClickOpen(selectedFile)
                                                            }}><Edit sx={{fontSize: "20px", color: "gray", marginRight: "10px"}}/>Módosítás</MenuItem>
                                                            <MenuItem onClick={() => {
                                                                handleFileContextClose()
                                                                props.changeProductImage(id, selectedFile.id)
                                                            }}><Image sx={{fontSize: "20px", color: "gray", marginRight: "10px"}}/>Beállítás képként</MenuItem>
                                                            <MenuItem onClick={() => {
                                                                props.removeDocumentName(selectedFile.id);
                                                                handleFileContextClose()
                                                            }}><Delete sx={{fontSize: "20px", color: "gray", marginRight: "10px"}}/>Törlés</MenuItem>
                                                        </Menu>

                                                    </TableCell>
                                                    <TableCell key={index}
                                                               sx={{textAlign: "left", padding: "5px"}}>
                                                        <Link
                                                            onClick={() => download(file.name, `/cloud-storage-files/${file.id}`, props.sendAlertMessage)}
                                                            sx={{
                                                                textDecoration: "none",
                                                                cursor: "pointer",
                                                                fontWeight: "bold"
                                                            }}>{file.name}</Link>
                                                    </TableCell>
                                                    <TableCell>
                                                        {file.description}
                                                    </TableCell>

                                                    <TableCell>{file.createdAt}</TableCell>
                                                    <TableCell>{file.uploadedBy?.name}</TableCell>
                                                </TableRow>
                                            ))}
                                            {props.files?.map((file, index) => (
                                                <TableRow>
                                                    <TableCell sx={{width: "50px", padding: "0px"}}>
                                                        <Button
                                                            onClick={() => props.handleRemoveFile(index)}
                                                            variant="text" color='error' sx={{
                                                            marginLeft: "10px",
                                                            padding: "5px",
                                                            minWidth: "0px"
                                                        }}>
                                                            <Close/>
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell key={index} sx={{
                                                        textAlign: "left",
                                                        padding: "0px 0px 0px 5px"
                                                    }}>
                                                        {file.name} {' ('}{(new Intl.NumberFormat().format((file.size / 1024).toFixed(2))).replace(',', '.')} KB{')'}
                                                    </TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </form>
            </div>

            <Paper sx={{width: '100%', overflow: 'hidden', margin: "20px 0px"}}>
                <TableContainer style={{maxHeight: "calc(100vh - 160px)"}}>
                    <Table stickyHeader aria-label="sticky table" sx={{tableLayout: "fixed"}}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{width: "60px", background: "lightgray"}}></TableCell>
                                {columns.map((column) => (
                                    <TableCell key={column.id} align={column.align}
                                               style={{fontWeight: 700, background: "lightgray", padding: "0px 5px", width: column.width ? column.width : "auto"}}>
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {waitingForCorrection ?
                                <TableRow sx={{textAlign: "center"}}>
                                    <TableCell colSpan={8} sx={{padding: "40px", textAlign: "center"}}>
                                        <CircularProgress/>
                                    </TableCell>
                                </TableRow>
                                : productItems && productItems.map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                        <TableCell padding='none' align='center' sx={{padding: "0px", lineHeight: "0px !important"}}>
                                            <div style={{
                                                display: "inline-flex",
                                                width: "100%",
                                                justifyContent: "space-between",
                                            }}>
                                                <Tooltip title={indexOfEditedRow === index ? "Mentés" : "Szerkesztés"} placement="left" enterDelay={1000}>
                                                    {indexOfEditedRow === index ?
                                                        <Save onClick={e => editOrSaveClick(e, index)} sx={iconButtonStyle}/> :
                                                        <Edit onClick={e => editOrSaveClick(e, index)} sx={iconButtonStyle}/>
                                                    }
                                                </Tooltip>
                                                <Tooltip title={"Mennyiség korrekció"} placement="right" enterDelay={1000}>
                                                    <Settings sx={iconButtonStyle} onClick={() => handleClickOpen(row)}/>
                                                </Tooltip>
                                            </div>
                                        </TableCell>
                                        {columns.map((column) => {
                                            let value = column.subId != null ? row[column.id][column.subId] : row[column.id];
                                            if (column.id === "subStorage")
                                                value = row.subStorage?.name || row.subStorage?.project?.name
                                                    || (row.subStorage?.productProjectIteration?.productProject?.name + " (" + row.subStorage?.productProjectIteration?.serialNumber + ". gyártási ciklus)")
                                            return (
                                                <TableCell key={column.id} align={column.align} sx={{padding: "0px 10px", '& input': {fontSize: "0.8rem !important", padding: "0px"}}}>
                                                    {(indexOfEditedRow === index && column.editable) ?
                                                        <TextField name={column.id}
                                                                   variant='standard'
                                                                   onChange={e => onChangeProductItem(e, index)} value={value}
                                                                   type={column.type || "text"}>
                                                        </TextField>
                                                        : (value == null ? "" : value.toLocaleString())}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries((formData).entries());
                        correctAmount(currentItem.id, formJson.amount);
                        handleClose();
                    },
                }}
            >
                <DialogTitle sx={{background: "#9c27b0", color: "white"}}>Termék
                    Példány Mennyiség Korrekció</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        name="amount"
                        label="Mennyiség"
                        fullWidth
                        defaultValue={currentItem?.amount}
                        variant="standard"
                    />
                </DialogContent>
                <DialogActions>
                    <Button type="submit" color="secondary" variant="contained"
                            sx={{marginRight: "auto"}}>Mentés</Button>
                    <Button onClick={handleClose} color="error"
                            variant="outlined">Mégse</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openFileDialog}
                onClose={handleFileDialogClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries((formData).entries());
                        props.updateFileDescription(fileDialogCurrentItem.id, formJson)
                        handleFileDialogClose();
                    },
                }}
            >
                <DialogTitle sx={{background: "#1976d2", color: "white"}}>
                    Fájl Leírás Módosítása
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        name="description"
                        label="Leírás"
                        fullWidth
                        autoComplete="off"
                        defaultValue={fileDialogCurrentItem?.description}
                        variant="standard"
                    />
                </DialogContent>
                <DialogActions>
                    <Button type="submit" variant="contained"
                            sx={{marginRight: "auto"}}>Mentés</Button>
                    <Button onClick={handleFileDialogClose} color="error"
                            variant="outlined">Mégse</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}